"use client"

import type { ReactNode } from "react"

import { ConfidenceMeter } from "@/components/question-quality/question-quality-finding"
import { cn } from "@/lib/utils"

export function LeoSpottedMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex size-5 shrink-0 items-center justify-center rounded-full bg-brand/10",
        className,
      )}
    >
      <i
        className="fa-duotone fa-solid fa-star-christmas text-xs text-brand"
        aria-hidden="true"
      />
    </span>
  )
}

export function LeoSpottedHeader({
  nowScore,
  actions,
  className,
}: {
  nowScore?: number
  actions?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-3 border-b border-border px-3.5 pb-3 pt-3",
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        <LeoSpottedMark />
        <h2 className="text-base font-bold leading-tight tracking-tight text-foreground">
          Leo spotted
        </h2>
      </div>
      <div className="flex shrink-0 items-center gap-1.5">
        {nowScore != null ? (
          <ConfidenceMeter value={nowScore} now lineItem />
        ) : null}
        {actions}
      </div>
    </div>
  )
}
